<!-- Global org selector ABOVE tabs -->
<div class="flex items-center gap-4 mb-4 flex-wrap">
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>{{ 'Organization' | translate }}</mat-label>
    <mat-select [(ngModel)]="selectedOrgId" (selectionChange)="onOrgChange()">
      @for (org of organizations; track org.id) {
      <mat-option [value]="org.id">
        {{ org.org_name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<mat-tab-group animationDuration="200ms">
  <mat-tab [label]="'Manage Roles' | translate">
    <app-manage-roles [orgId]="selectedOrgId" (rolesChanged)="onRolesChanged()" />
  </mat-tab>
  <mat-tab [label]="'Assign to Users' | translate">
    <app-assign-users [orgId]="selectedOrgId" />
  </mat-tab>
</mat-tab-group>
